import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { GENERAL_INCOME_TYPE_PATH } from '../../../../config/paths';
import {
  clearGeneralIncomeType,
  getGeneralIncomeType,
  putGeneralIncomeType,
} from '../../../../actions';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import GeneralIncomeTypeForm from './GeneralIncomeTypeForm';
import { GENERAL_INCOME_TYPE_LABEL } from '../../../../config/constants';

const EditGeneralIncomeType = ({
  breadcrumbs,
  dispatchGetGeneralIncomeType,
  dispatchClearGeneralIncomeType,
  dispatchPutGeneralIncomeType,
  match: {
    params: { id: generalIncomeTypeId },
  },
  loading,
  generalIncomeType,
}) => {
  useLayoutEffect(() => {
    dispatchGetGeneralIncomeType({ generalIncomeTypeId });

    return () => dispatchClearGeneralIncomeType();
  }, []);

  const onSubmit = (formValues) =>
    dispatchPutGeneralIncomeType(generalIncomeTypeId, {
      ...formValues,
      generalIncomeTypeLabel: formValues.generalIncomeTypeLabelId.value
    });

  const generateInitialValues = ({
    name,
    description,
    expenseCode,
    generalIncomeTypeLabel
  }) => ({
    name,
    description,
    expenseCode,
    generalIncomeTypeLabelId: GENERAL_INCOME_TYPE_LABEL[generalIncomeTypeLabel]
  });

  let content;

  if (loading) content = <Loader />;
  else if (generalIncomeType.isEmpty())
    content = <NoDataResource returnPage={GENERAL_INCOME_TYPE_PATH} />;
  else
    content = (
      <GeneralIncomeTypeForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(generalIncomeType.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Tipo de Ingreso"
      subtitle="Editar tipo de ingreso"
      content={content}
    />
  );
};

EditGeneralIncomeType.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearGeneralIncomeType: PropTypes.func.isRequired,
  dispatchGetGeneralIncomeType: PropTypes.func.isRequired,
  dispatchPutGeneralIncomeType: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  generalIncomeType: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditGeneralIncomeType.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearGeneralIncomeType: clearGeneralIncomeType,
  dispatchGetGeneralIncomeType: getGeneralIncomeType,
  dispatchPutGeneralIncomeType: putGeneralIncomeType,
};

const mapStateToProps = (
  { AccountingUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Ingreso',
      href: GENERAL_INCOME_TYPE_PATH,
    },
    {
      text: 'Ver',
      href: `${GENERAL_INCOME_TYPE_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  generalIncomeType: AccountingUnit.GeneralIncomeType.getIn(['current', 'content']),
  loading: !AccountingUnit.GeneralIncomeType.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditGeneralIncomeType);
